const INITIAL_VALUE = {
  "tracks": {
    "data": [
      {
        "id": 1391349252,
        "title": "Meu Pedaço de Pecado",
        "title_short": "Meu Pedaço de Pecado",
        "title_version": "",
        "link": "http://www.deezer.com/track/1391349252",
        "duration": 157,
        "rank": 999308,
        "explicit_lyrics": false,
        "explicit_content_lyrics": 0,
        "explicit_content_cover": 0,
        "preview": "http://cdn-preview-7.deezer.com/stream/c-70255a40b7c438c3239e94ba0c909128-3.mp3",
        "md5_image": "44c144f53d3c4e3ca5e8c6b9ee13ed27",
        "position": 1,
        "artist": {
          "id": 135512622,
          "name": "João Gomes",
          "link": "http://www.deezer.com/artist/135512622",
          "picture": "http://api.deezer.com/artist/135512622/image",
          "picture_small": "http://e-cdn-images.dzcdn.net/images/artist/65e1fbf38b84a7d0380b754452886aa8/56x56-000000-80-0-0.jpg",
          "picture_medium": "http://e-cdn-images.dzcdn.net/images/artist/65e1fbf38b84a7d0380b754452886aa8/250x250-000000-80-0-0.jpg",
          "picture_big": "http://e-cdn-images.dzcdn.net/images/artist/65e1fbf38b84a7d0380b754452886aa8/500x500-000000-80-0-0.jpg",
          "picture_xl": "http://e-cdn-images.dzcdn.net/images/artist/65e1fbf38b84a7d0380b754452886aa8/1000x1000-000000-80-0-0.jpg",
          "radio": true,
          "tracklist": "http://api.deezer.com/artist/135512622/top?limit=50",
          "type": "artist"
        },
        "album": {
          "id": 234349272,
          "title": "Eu Tenho a Senha",
          "cover": "http://api.deezer.com/album/234349272/image",
          "cover_small": "http://e-cdn-images.dzcdn.net/images/cover/44c144f53d3c4e3ca5e8c6b9ee13ed27/56x56-000000-80-0-0.jpg",
          "cover_medium": "http://e-cdn-images.dzcdn.net/images/cover/44c144f53d3c4e3ca5e8c6b9ee13ed27/250x250-000000-80-0-0.jpg",
          "cover_big": "http://e-cdn-images.dzcdn.net/images/cover/44c144f53d3c4e3ca5e8c6b9ee13ed27/500x500-000000-80-0-0.jpg",
          "cover_xl": "http://e-cdn-images.dzcdn.net/images/cover/44c144f53d3c4e3ca5e8c6b9ee13ed27/1000x1000-000000-80-0-0.jpg",
          "md5_image": "44c144f53d3c4e3ca5e8c6b9ee13ed27",
          "tracklist": "http://api.deezer.com/album/234349272/tracks",
          "type": "album"
        },
        "type": "track"
      }
    ],
    "total": 1
  },
  "albums": {
    "data": [
      {
        "id": 278864922,
        "title": "Buteco in Boston (Ao Vivo)",
        "link": "http://www.deezer.com/album/278864922",
        "cover": "http://api.deezer.com/album/278864922/image",
        "cover_small": "http://e-cdn-images.dzcdn.net/images/cover/403d532b92585bfb810e122f47d33dc9/56x56-000000-80-0-0.jpg",
        "cover_medium": "http://e-cdn-images.dzcdn.net/images/cover/403d532b92585bfb810e122f47d33dc9/250x250-000000-80-0-0.jpg",
        "cover_big": "http://e-cdn-images.dzcdn.net/images/cover/403d532b92585bfb810e122f47d33dc9/500x500-000000-80-0-0.jpg",
        "cover_xl": "http://e-cdn-images.dzcdn.net/images/cover/403d532b92585bfb810e122f47d33dc9/1000x1000-000000-80-0-0.jpg",
        "md5_image": "403d532b92585bfb810e122f47d33dc9",
        "record_type": "album",
        "tracklist": "http://api.deezer.com/album/278864922/tracks",
        "explicit_lyrics": false,
        "position": 1,
        "artist": {
          "id": 1541592,
          "name": "Gusttavo Lima",
          "link": "http://www.deezer.com/artist/1541592",
          "picture": "http://api.deezer.com/artist/1541592/image",
          "picture_small": "http://e-cdn-images.dzcdn.net/images/artist/cac3ec4786f8be6dedf24233149db49d/56x56-000000-80-0-0.jpg",
          "picture_medium": "http://e-cdn-images.dzcdn.net/images/artist/cac3ec4786f8be6dedf24233149db49d/250x250-000000-80-0-0.jpg",
          "picture_big": "http://e-cdn-images.dzcdn.net/images/artist/cac3ec4786f8be6dedf24233149db49d/500x500-000000-80-0-0.jpg",
          "picture_xl": "http://e-cdn-images.dzcdn.net/images/artist/cac3ec4786f8be6dedf24233149db49d/1000x1000-000000-80-0-0.jpg",
          "radio": true,
          "tracklist": "http://api.deezer.com/artist/1541592/top?limit=50",
          "type": "artist"
        },
        "type": "album"
      }
    ],
    "total": 1
  },
  "artists": {
    "data": [
      {
        "id": 61474832,
        "name": "Os Barões Da Pisadinha",
        "link": "http://www.deezer.com/artist/61474832",
        "picture": "http://api.deezer.com/artist/61474832/image",
        "picture_small": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/56x56-000000-80-0-0.jpg",
        "picture_medium": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/250x250-000000-80-0-0.jpg",
        "picture_big": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/500x500-000000-80-0-0.jpg",
        "picture_xl": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/1000x1000-000000-80-0-0.jpg",
        "radio": true,
        "tracklist": "http://api.deezer.com/artist/61474832/top?limit=50",
        "position": 1,
        "type": "artist"
      }],
    "total": 1
  },
  "playlists": {
    "data": [
      {
        "id": 973678543,
        "title": "Explosão Brasil",
        "public": true,
        "nb_tracks": 50,
        "link": "http://www.deezer.com/playlist/973678543",
        "picture": "http://api.deezer.com/playlist/973678543/image",
        "picture_small": "http://e-cdn-images.dzcdn.net/images/playlist/d854db73d6f4b874a16c89f3db544c05/56x56-000000-80-0-0.jpg",
        "picture_medium": "http://e-cdn-images.dzcdn.net/images/playlist/d854db73d6f4b874a16c89f3db544c05/250x250-000000-80-0-0.jpg",
        "picture_big": "http://e-cdn-images.dzcdn.net/images/playlist/d854db73d6f4b874a16c89f3db544c05/500x500-000000-80-0-0.jpg",
        "picture_xl": "http://e-cdn-images.dzcdn.net/images/playlist/d854db73d6f4b874a16c89f3db544c05/1000x1000-000000-80-0-0.jpg",
        "checksum": "e51a20c337b6f991da09292c70be5b2f",
        "tracklist": "http://api.deezer.com/playlist/973678543/tracks",
        "creation_date": "2014-09-01 12:04:38",
        "md5_image": "d854db73d6f4b874a16c89f3db544c05",
        "picture_type": "playlist",
        "user": {
          "id": 303004553,
          "name": "Romar - Editor Deezer Brasil",
          "tracklist": "http://api.deezer.com/user/303004553/flow",
          "type": "user"
        },
        "type": "playlist"
      }
    ],
    "total": 1
  },
  "podcasts": {
    "data": [
      {
        "id": 1950252,
        "title": "Não Inviabilize",
        "description": "O canal Não Inviabilize é um espaço de contos e crônicas, um laboratório de histórias reais. Aqui você ouve as suas histórias misturadas às minhas!  Quadros do canal: Amor Nas Redes - histórias de amor, afeto, saudade; Picolé de Limão - histórias do cotidiano, ciladas, trapaças, muita história revoltante; Luz Acesa - histórias de terror, suspense e mistério; Ficção da Realidade - histórias ficcionais interativas; Mico Meu - histórias engraçadas; Alarme - histórias que servem de alerta, gatilhos emocionais.  Site: naoinviabilize.com.br E-mail: naoinviabilize@gmail.com",
        "available": true,
        "fans": 9489,
        "link": "http://www.deezer.com/show/1950252",
        "share": "https://www.deezer.com/show/1950252?utm_source=deezer&utm_content=show-1950252&utm_term=0_1640122208&utm_medium=web",
        "picture": "http://e-cdn-images.dzcdn.net/images/talk/c7b35fe4be12bfdb4a14fdbe6b1ad552/180x180-000000-80-0-0.jpg",
        "picture_small": "http://e-cdn-images.dzcdn.net/images/talk/c7b35fe4be12bfdb4a14fdbe6b1ad552/56x56-000000-80-0-0.jpg",
        "picture_medium": "http://e-cdn-images.dzcdn.net/images/talk/c7b35fe4be12bfdb4a14fdbe6b1ad552/250x250-000000-80-0-0.jpg",
        "picture_big": "http://e-cdn-images.dzcdn.net/images/talk/c7b35fe4be12bfdb4a14fdbe6b1ad552/500x500-000000-80-0-0.jpg",
        "picture_xl": "http://e-cdn-images.dzcdn.net/images/talk/c7b35fe4be12bfdb4a14fdbe6b1ad552/1000x1000-000000-80-0-0.jpg",
        "type": "podcast"
      }
    ],
    "total": 1
  },
  "trendingArtist": {
      "id": 61474832,
      "name": "Os Barões Da Pisadinha",
      "link": "http://www.deezer.com/artist/61474832",
      "picture": "http://api.deezer.com/artist/61474832/image",
      "picture_small": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/56x56-000000-80-0-0.jpg",
      "picture_medium": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/250x250-000000-80-0-0.jpg",
      "picture_big": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/500x500-000000-80-0-0.jpg",
      "picture_xl": "http://e-cdn-images.dzcdn.net/images/artist/96d7c67670d6b70d26cf41f2ced575ee/1000x1000-000000-80-0-0.jpg",
      "radio": true,
      "tracklist": "http://api.deezer.com/artist/61474832/top?limit=50",
      "position": 1,
      "type": "artist"
  }
}

export { INITIAL_VALUE }